import { render, staticRenderFns } from "./PlanShifter.vue?vue&type=template&id=dd7955da&scoped=true&"
import script from "./PlanShifter.vue?vue&type=script&lang=js&"
export * from "./PlanShifter.vue?vue&type=script&lang=js&"
import style0 from "./PlanShifter.vue?vue&type=style&index=0&id=dd7955da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7955da",
  null
  
)

export default component.exports